import axios from 'axios';
import loadjs from 'loadjs';

let firebasePollingTimeoutId;
let isLoadingFirebase = false;

const loadFirebaseScripts = ({ unpkgUrl }) => {
  return new Promise((resolve) => {
    const files = [
      `${unpkgUrl}/firebase@5.7.3/firebase-app.js`,
      `${unpkgUrl}/firebase@5.7.3/firebase-auth.js`,
      `${unpkgUrl}/firebase@5.7.3/firebase-database.js`,
    ];
    loadjs(files, {
      async: false,
      numRetries: 3,
      before: (path, scriptEl) => {
        scriptEl.crossOrigin = 'anonymous';
      },
      success: () => {
        resolve();
      },
    });
  });
};

const pollUrl = (url: string, { maxAttempts, interval }) => {
  const pollInternal = (numberOfAttempt = 1) => {
    return new Promise((resolve) => {
      fetch(url)
        .then((res) => res.json())
        .then(async (res) => {
          if (res || numberOfAttempt === maxAttempts) {
            resolve();
          } else {
            firebasePollingTimeoutId = setTimeout(
              () => pollInternal(++numberOfAttempt),
              interval,
            );
          }
        })
        .catch(() => resolve());
    });
  };

  return pollInternal();
};

const getFirebaseEventsUrl = async (chatToken: string) => {
  const realtimeToken = await axios
    .post('/_api/chat-web/v1/real-time-tokens', {
      token: chatToken,
    })
    .then((res) => res.data);

  const firebaseToken = await fetch(
    `https://www.googleapis.com/identitytoolkit/v3/relyingparty/verifyCustomToken?key=${realtimeToken.options.apiKey}`,
    {
      body: JSON.stringify({
        token: realtimeToken.authKey,
        returnSecureToken: true,
      }),
      method: 'POST',
    },
  ).then((res) => res.json());

  return `${realtimeToken.options.databaseURL}${realtimeToken.eventsPath.substr(
    1,
  )}.json?auth=${firebaseToken.idToken}`;
};

export const lazilyLoadFirebase = async (
  unpkgUrl: string,
  chatToken: string,
  maxDelay: number,
) => {
  const maxAttempts = 2;
  const eventsUrl = await getFirebaseEventsUrl(chatToken);

  await pollUrl(eventsUrl, {
    interval: Math.round(maxDelay / maxAttempts),
    maxAttempts,
  });

  return loadFirebase(unpkgUrl);
};

export const loadFirebase = (unpkgUrl: string) => {
  if (!isLoadingFirebase) {
    isLoadingFirebase = true;

    if (firebasePollingTimeoutId) {
      window.clearTimeout(firebasePollingTimeoutId);
      firebasePollingTimeoutId = undefined;
    }

    return loadFirebaseScripts({ unpkgUrl });
  }

  return Promise.resolve();
};
